import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
export const ConjuntoConcursoListItem = ({
  conjuntosCategoria,
  conjuntos,
  setConjuntos,
  setterCategoria,
}) => {
  return (
    <>
      {conjuntosCategoria?.map((x) => {
        return (
          <div className="flex items-center gap-3 item">
            <div className="flex-1 text-start">
              <span>{x?.nombre}</span>
            </div>
            <div className="w-auto">
              <DeleteIcon
                className="action-icon"
                onClick={() => {
                  setterCategoria(
                    conjuntosCategoria.filter((y) => y.id != x.id)
                  );
                  setConjuntos(
                    conjuntos.map((z) => {
                      if (z.id == x.id) {
                        return { ...z, agregado: false };
                      } else {
                        return z;
                      }
                    })
                  );
                }}
              />
            </div>
          </div>
        );
      })}
    </>
  );
};
